import DataRecovery from "../../components/DataRecovery";
import EmptyState, { emptyStateActionClass } from "../../components/EmptyState";

export default function AnalysisTableState({ loading, error, onRetry, onAdjustFilters }: {
  loading: boolean; error: Error | null; onRetry: () => void; onAdjustFilters: (opener: HTMLButtonElement) => void;
}) {
  return <div className="rounded-lg border border-slate-200 bg-white p-5 sm:p-6">
    {loading ? <p role="status" className="text-sm text-slate-600">Lade Positionen …</p>
      : error ? <DataRecovery error={error} subject="Die Auswertungsdaten" onRetry={onRetry} />
      : <EmptyState title="Keine Positionen für diese Auswahl" actions={<button className={emptyStateActionClass} onClick={event => onAdjustFilters(event.currentTarget)}>Filter prüfen</button>}>
        Für die aktuellen Filter und die gewählte Vergleichsbasis gibt es keine Treffer. Prüfe Zeitraum, Prüfstatus und weitere Einschränkungen. Eine leere Liste bestätigt nicht, dass alle Preise unauffällig sind.
      </EmptyState>}
  </div>;
}
